import {resources} from "../../../../../../../core/models/resource/resources";

export const factoryBankDetailsResourceType = resources['factory-bank-details'];
